"use client";
import React from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "./client.module.scss";

interface Props {
  data: any;
}
const RequestProposalSolution: React.FC<Props> = ({ data }) => {
  const url = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

  return (
    <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white ">
      <div className="container">
        <div className="heading mb-[40px] lg:mb-[40px] xl:mb-[40px]">
          <h2 className="lg:text-[48px] xl:text-[65px] xm:text-[32px] xm:text-[32px] text-[26px] text-center xl:leading-[83.3px] lg:leading-[62.4px] xm:leading-[41.6px] leading-[35px] font-[700] text-[#040405]">
            {data.title}
          </h2>
          <p className="text-[#32343B] text-[20px] leading-[26px] xl:text-[24px] xl:leading-[31.1px] text-center">
            {data.short_title}
          </p>
        </div>
        {data?.Projects?.map((item: any, i: number) => (
          <div
            key={"Projects" + i}
            className="bg-white lg:p-[48px_16px] md:p-[24px_24px] p-[24px_12px] border-[#B0D9F7] border-[1px] group md:mb-[30px] mb-[20px]"
          >
            <div className="grid grid-cols-1 xl:grid-cols-[60%_auto] 2xl:grid-cols-[70%_auto] mb-[24px] lg:mb-[32px] lg:gap-[16px]">
              <div>
                <h2 className="text-[#040405] font-[700] text-[28px] lg:text-[32px] xl:text-[36px] leading-[36px] lg:leading-[46.6px] xl:leading-[46.8px] mb-[20px] tracking-[1px]">
                  {item?.Title ?? ""}
                </h2>
              </div>
              <div className="flex justify-center xl:justify-end md:gap-[16px] gap-[8px] xl:gap-[30px] ">
                {item?.key_points?.map((project: any, i: number) => (
                  <React.Fragment key={i}>
                    {(i + 1) % 2 !== 0 ? (
                      <div
                        key={"project-" + i + "-key-points"}
                        className="p-[13px_11px] sm:p-[20px_12px] bg-[#E6F3FD] flex flex-col w-full max-w-[100%] xl:max-w-[153px]  lg:h-auto sm:h-[104px] xs:h-[89px] [@media(max-width:400px)]:h-auto"
                      >
                        <p className="text-[14px] sm:whitespace-normal whitespace-nowrap [@media(max-width:400px)]:whitespace-normal  leading-[19.8px] xl:text-[16px] xl:leading-[22px] font-[400] text-[#000000] mb-[16px]">
                          {project.title ?? ""}
                        </p>
                        <h5 className="font-[600] text-[22px] leading-[28.6px] lg:text-[24px] lg:leading-[31.6px] xl:text-[32px] xl:leading-[41.6px] text-[#000000]">
                          {project.numbers ?? ""}
                        </h5>
                      </div>
                    ) : (
                      <div className="p-[13px_11px] sm:p-[20px_12px] bg-[#F3F8E6] flex flex-col w-full max-w-[100%] lg:h-auto xl:max-w-[153px] sm:h-[104px] xs:h-[89px] [@media(max-width:400px)]:h-auto ">
                        <p className="text-[14px] leading-[19.8px] sm:whitespace-normal whitespace-nowrap [@media(max-width:400px)]:whitespace-normal xl:text-[16px] xl:leading-[22px] font-[400] text-[#000000] mb-[16px]">
                          {project.title ?? ""}
                        </p>
                        <h5 className="font-[600] text-[22px] leading-[28.6px] lg:text-[24px] lg:leading-[31.6px] xl:text-[32px] xl:leading-[41.6px] text-[#000000]">
                          {project.numbers ?? ""}

                          <span
                            className=" text-[14px] leading-[19.8px] xl:text-[16px] xl:leading-[22px] font-[400] text-[#000000] sm:hidden inline-block"
                            dangerouslySetInnerHTML={{
                              __html: project.description ?? "",
                            }}
                          />
                        </h5>
                        <span
                          className=" text-[14px] leading-[19.8px] xl:text-[16px] xl:leading-[22px] font-[400] text-[#000000] sm:block hidden"
                          dangerouslySetInnerHTML={{
                            __html: project.description ?? "",
                          }}
                        />
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
            <div className="mb-[24px] lg:mb-[32px] relative">
              {item?.Snapshots?.data?.attributes?.url && (
                <Link
                  href={item?.link?.href ?? "/"}
                  className="block"
                  onClick={(e) => {
                    e.preventDefault();
                    if (item?.link?.href)
                      window.open(item?.link?.href, "_blank");
                  }}
                >
                  <Image
                    src={url + item?.Snapshots?.data?.attributes?.url}
                    alt="image"
                    width={1182}
                    height={360}
                    className="w-full h-[360px] block object-cover cursor-pointer"
                  />
                </Link>
              )}
              {item?.technologies?.map((tech: any, i: number) => (
                <div
                  key={"tech-" + i}
                  className="absolute w-full left-0 bottom-0 px-[0px] pt-[20px] md:p-[20px_25px] bg-[linear-gradient(180deg,rgba(176,217,247,0.3)_0%,#0086E680_100%)] backdrop-blur-[10px] overflow-hidden"
                >
                  <div className="flex justify-between items-center md:flex-row flex-col gap-[20px]">
                    <p className="text-white  font-[600] text-[16px] leading-[22.2px]">
                      {tech.title ?? ""}
                    </p>
                    <div
                      className={`mb-[10px] sm:mb-[0px] w-[100%] sm:w-[40%] xl:w-[20%] ${
                        tech?.technologies?.length >= 5 ? styles.marque : ""
                      }`}
                    >
                      <div
                        className={`${
                          tech?.technologies?.length >= 5
                            ? styles.marqueTrack
                            : "flex justify-end gap-[12px]"
                        }`}
                      >
                        {tech?.technologies?.map((stack: any, idx: number) => (
                          <div
                            key={"stack-" + idx}
                            className={`${tech?.technologies?.length >= 5 ? styles.marqueInner : "bg-white flex-shrink-0 flex justify-center items-center w-[42px] h-[42px]"}`}
                          >
                            {stack?.image?.data?.attributes?.url ? (
                              <Image
                                width={42}
                                height={42}
                                src={url + stack?.image?.data?.attributes?.url}
                                alt={stack?.image?.data?.attributes?.name}
                                className="w-[32px] h-[32px] block object-cover"
                                quality={100}
                              />
                            ) : (
                              <div className="w-[32px] h-[32px] bg-[#E6EAF0]" />
                            )}
                          </div>
                        ))}

                        {/* Only duplicate if 5 or more images */}
                        {tech?.technologies?.length >= 5 &&
                          tech?.technologies?.map((stack: any, idx: number) => (
                            <div
                              key={"stack-dup-" + idx}
                              className={styles.marqueInner}
                            >
                              {stack?.image?.data?.attributes?.url ? (
                                <Image
                                  width={42}
                                  height={42}
                                  src={
                                    url + stack?.image?.data?.attributes?.url
                                  }
                                  alt={stack?.image?.data?.attributes?.name}
                                  className="w-[32px] h-[32px] block object-cover"
                                  quality={100}
                                />
                              ) : (
                                <div className="w-[32px] h-[32px] bg-[#E6EAF0]" />
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <p className="text-[#040405] font-[400] text-[16px] leading-[24.4px] xl:text-[20px] xl:leading-[28px]">
              {item.Description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RequestProposalSolution;
